import { render, staticRenderFns } from "./RolesPermissions.vue?vue&type=template&id=bbde9364&scoped=true&"
import script from "./RolesPermissions.vue?vue&type=script&lang=js&"
export * from "./RolesPermissions.vue?vue&type=script&lang=js&"
import style0 from "./RolesPermissions.vue?vue&type=style&index=0&id=bbde9364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbde9364",
  null
  
)

export default component.exports